<div class="field-group">
  <p-iftalabel class="w-full">
    @if (control(); as ctrl) {
      <p-select class="w-full"
                filterBy="label"
                optionLabel="label"
                optionValue="value"
                [editable]="editable()"
                [filter]="true"
                [formControlName]="controlName()"
                [id]="inputId()"
                [invalid]="invalid()"
                [options]="countryOptions()"
                [placeholder]="placeholder()"
      />
    }
    <label class="block font-medium mb-1"
           [for]="inputId()"
    >
      {{ label() }}
    </label>
  </p-iftalabel>
  @if (showRequiredHint) {
    <small class="block text-red-500 text-xs mt-1">{{ label() }} is required.</small>
  }
</div>
